<div [class]="theme">
  <div edsGrid>
    <div class="container--wide">
      <ft-intro-section
        [showCta]="content?.cards?.length > 0 ? false : true"
        [content]="content"
        [titleColorTheme]="titleColorTheme"
      ></ft-intro-section>

      <div edsRow>
        <div
          edsCol
          edsFlexbox
          [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
        >
          <ng-container *ngIf="content?.cards">
            <ng-container *ngFor="let card of cards">
              <eds-card-index-compact
                edsFlexItem
                [flexBasis]="0"
                [flexGrow]="1"
                [isEdsIcon]="false"
                [isImg]="true"
                [imgSrc]="card.imageSrc"
                [title]="card.title"
                [isNewWindow]="card.link?.target == '_blank' ? true : false"
                [externalLink]="card.link?.external"
                [externalSuffix]="card.link?.externalSuffix"
                [signInRequired]="
                  card.link?.signInLink | ftIsSignInRequired | async
                "
                [hideLockIcon]="card.link?.hideLockIcon"
                [signInTooltip]="'common.locked-link-tooltip' | translate"
                [centerAligned]="
                  sectionType === 'index_cards_compact_centered' ? true : false
                "
                [href]="card.href"
                theme="light"
                [analyticsNoEvent]="true"
              >
              </eds-card-index-compact>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
